import { withInstall } from '@lit-element/utils'
import Autocomplete from './src/autocomplete.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtAutocomplete: SFCWithInstall<typeof Autocomplete> =
  withInstall(Autocomplete)

export default LtAutocomplete

export * from './src/autocomplete'
